import ModalTable from "./ModalTable.component.jsx";

export default ModalTable;